module.exports = __webpack_public_path__ + "img/sjoelen3.1d7d70b4.jpeg";